import React, { memo } from "react";

import { AccordionList, Accordion } from 'onefaceui-react-components';

import { replaceSizeAlias } from "react/utils/utils";

const ExtraLineItem = ({ extraLineItemArray, i18n }) => {

  const extraLineItemList = extraLineItemArray.map(item =>
    <Accordion
      key={item.id}
      dataTestId="additionalMaterial"
      label={item.sku.description}
    >
        <div className="lineContainer">
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.plannedSize1")
              )}
            </div>
            <div className="quantity">{item.plannedSize1}</div>
          </div>
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.plannedSize2")
              )}
            </div>
            <div className="quantity">{item.plannedSize2}</div>
          </div>
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.plannedSize3")
              )}
            </div>
            <div className="quantity">{item.plannedSize3}</div>
          </div>
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.availableSize1")
              )}
            </div>
            <div className="quantity">{item.availableSize1}</div>
          </div>
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.availableSize2")
              )}
            </div>
            <div className="quantity">{item.availableSize2}</div>
          </div>
          <div className="line">
            <div className="sizes">
              {replaceSizeAlias(
                i18n.getResourcesByKey("route.extra.line.item.availableSize3")
              )}
            </div>
            <div className="quantity">{item.availableSize3}</div>
          </div>
        </div>
    </Accordion>
  );

  return (
    <div id="extraLineItemContainer">
      <AccordionList size="md">
        {extraLineItemList}
      </AccordionList>
    </div>
  );
};

export default memo(ExtraLineItem);
